exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swR4 {\n    display: -ms-flexbox;\n    display: flex;\n    background: none;\n    border: none;\n    padding: 0;\n    -ms-flex-align: center;\n        align-items: center;\n    position: relative;\n}\n\n.tkF_ {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n}\n\n._1TcG {\n    height: 24px;\n    width: 24px;\n}\n\n._1jKw {\n    font-weight: 600;\n    margin-left: 5px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"container": "swR4",
	"right": "tkF_",
	"icon": "_1TcG",
	"text": "_1jKw"
};